// FitMar.cz – Scroll-triggered animations for product descriptions
(function () {
  var COUNTER_INIT_ATTR = "data-fm-counter-initialized";
  var COUNTER_WARN_ATTR = "data-fm-counter-warning";
  var COUNTER_OBSERVED_ATTR = "data-fm-counter-observed";
  var REVEAL_OBSERVED_ATTR = "data-fm-reveal-observed";
  var COMPARE_SCROLL_ATTR = "data-fm-compare-scroll";

  function forEachNode(nodes, callback) {
    Array.prototype.forEach.call(nodes || [], callback);
  }

  function getScopedElements(root, selector) {
    var scope = root || document;
    var elements = [];

    if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      forEachNode(scope.querySelectorAll(selector), function (el) {
        elements.push(el);
      });
    }

    return elements;
  }

  function normalizeText(value) {
    var text = String(value || "");
    if (typeof text.normalize === "function") {
      text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    return text.replace(/[łŁ]/g, "l").toLowerCase();
  }

  function mentionsProtein(value) {
    return /(bilkoviny|bilkovin|bialka|bialko|bielkoviny|bielkovin|protein|feherje)/.test(normalizeText(value));
  }

  function parseDecimal(value) {
    var match = String(value || "").match(/([+-]?\d+(?:[,.]\d+)?)/);
    if (!match) return null;
    var parsed = Number(match[1].replace(",", "."));
    return isFinite(parsed) ? parsed : null;
  }

  function parseLastPositiveGramValue(value) {
    var regex = /(\d+(?:[,.]\d+)?)\s*g\b/gi;
    var match;
    var grams = null;

    while ((match = regex.exec(String(value || "")))) {
      var parsed = Number(match[1].replace(",", "."));
      if (isFinite(parsed) && parsed > 0) grams = parsed;
    }

    return grams;
  }

  function parseLeadingMetric(value) {
    var text = String(value || "");
    var match = text.match(/^(\s*)([+-]?\d+(?:[,.]\d+)?)(\s*(?:kg|g|%|x|×|\+)?)([\s\S]*)$/i);
    if (!match) return null;

    var target = Number(match[2].replace(",", "."));
    if (!isFinite(target)) return null;

    return {
      prefix: match[1] || "",
      target: target,
      decimals: (match[2].match(/[,.](\d+)/) || ["", ""])[1].length,
      suffix: match[3] || "",
      rest: match[4] || ""
    };
  }

  function formatCounterValue(value, decimals) {
    var fixed = value.toFixed(decimals);
    return decimals > 0 ? fixed.replace(".", ",") : fixed;
  }

  function findProteinPer100g(root) {
    var rows = (root || document).querySelectorAll ? (root || document).querySelectorAll(".fm-nutrition tr") : [];

    for (var i = 0; i < rows.length; i++) {
      var cells = rows[i].querySelectorAll("th,td");
      if (cells.length < 2) continue;

      if (!mentionsProtein(cells[0].textContent || "")) continue;

      var protein = parseDecimal(cells[cells.length - 1].textContent || "");
      if (protein !== null && protein > 0) return protein;
    }

    return null;
  }

  function warnSuspiciousZeroProtein(el, reason) {
    el.setAttribute(COUNTER_WARN_ATTR, "suspicious-zero-protein");

    if (window.console && typeof window.console.warn === "function") {
      window.console.warn("[FitMar counter] Suspicious zero protein metric", el, reason);
    } else if (typeof console !== "undefined" && typeof console.warn === "function") {
      console.warn("[FitMar counter] Suspicious zero protein metric", el, reason);
    }
  }

  function deriveProteinMetric(el, parsed, root) {
    var unit = normalizeText(parsed.suffix).replace(/\s+/g, "");
    var text = el.textContent || "";

    if (parsed.target !== 0 || unit !== "g" || !mentionsProtein(text)) {
      return parsed;
    }

    var proteinPer100g = findProteinPer100g(root || document);
    var packageGrams = parseLastPositiveGramValue(text);

    if (proteinPer100g === null) {
      warnSuspiciousZeroProtein(el, "missing protein per 100 g");
      return null;
    }

    if (packageGrams === null) {
      warnSuspiciousZeroProtein(el, "missing package grams");
      return null;
    }

    var proteinGrams = Math.round((proteinPer100g * packageGrams) / 100);
    if (!isFinite(proteinGrams) || proteinGrams <= 0) {
      warnSuspiciousZeroProtein(el, "derived value is not positive");
      return null;
    }

    return {
      prefix: parsed.prefix,
      target: proteinGrams,
      decimals: 0,
      suffix: parsed.suffix || "g",
      rest: parsed.rest
    };
  }

  function animateCounter(el, target, decimals, suffix, rest, prefix) {
    var textPrefix = prefix || "";
    var textRest = rest || "";
    var finalText = textPrefix + formatCounterValue(target, decimals) + suffix + textRest;
    var now = window.performance && typeof window.performance.now === "function"
      ? function () { return window.performance.now(); }
      : function () { return Date.now(); };
    var requestFrame = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(function () {
        callback(now());
      }, 16);
    };
    var duration = 1400;
    var start = now();

    el.setAttribute("aria-label", finalText);
    el.textContent = textPrefix + formatCounterValue(0, decimals) + suffix + textRest;

    function tick(timestamp) {
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = progress * (2 - progress);
      var value = eased * target;

      el.textContent = textPrefix + formatCounterValue(value, decimals) + suffix + textRest;

      if (progress < 1) {
        requestFrame(tick);
      } else {
        el.textContent = finalText;
      }
    }

    requestFrame(tick);
  }

  function runWhenVisible(el, callback) {
    var ran = false;

    function run() {
      if (ran) return;
      ran = true;
      callback();
    }

    if ("IntersectionObserver" in window) {
      var observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          run();
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.15 });

      observer.observe(el);
    } else {
      run();
    }
  }

  function initModernCounter(el) {
    if (el.getAttribute(COUNTER_INIT_ATTR) === "true") return;

    var target = parseDecimal(el.getAttribute("data-countup"));
    if (target === null) return;

    var decimals = parseInt(el.getAttribute("data-countup-decimals") || "0", 10);
    if (!isFinite(decimals) || decimals < 0) decimals = 0;

    var suffix = el.getAttribute("data-countup-suffix") || "";

    el.setAttribute(COUNTER_INIT_ATTR, "true");
    runWhenVisible(el, function () {
      animateCounter(el, target, decimals, suffix, "", "");
    });
  }

  function initLegacyCounter(el, root) {
    if (el.getAttribute(COUNTER_INIT_ATTR) === "true") return;
    if (el.querySelector("[data-countup], .fm-stat__number")) return;

    var desc = el.closest ? el.closest(".fm-desc") : null;
    if (!desc) return;

    var parsed = parseLeadingMetric(el.textContent || "");
    if (!parsed) return;

    parsed = deriveProteinMetric(el, parsed, desc || root || document);
    el.setAttribute(COUNTER_INIT_ATTR, "true");

    if (!parsed) return;

    runWhenVisible(el, function () {
      animateCounter(el, parsed.target, parsed.decimals, parsed.suffix, parsed.rest, parsed.prefix);
    });
  }

  function initCounters(root) {
    var scope = root || document;

    getScopedElements(scope, "[data-countup]").forEach(function (el) {
      initModernCounter(el);
    });

    getScopedElements(scope, ".fm-stat").forEach(function (el) {
      initLegacyCounter(el, scope);
    });
  }

  function observeCounterMutations(root) {
    if (!("MutationObserver" in window)) return;

    getScopedElements(root || document, ".fm-desc").forEach(function (desc) {
      if (desc.getAttribute(COUNTER_OBSERVED_ATTR) === "true") return;

      desc.setAttribute(COUNTER_OBSERVED_ATTR, "true");

      var observer = new window.MutationObserver(function () {
        initCounters(desc);
      });

      observer.observe(desc, { childList: true, subtree: true });
    });
  }

  function reveal(el) {
    el.classList.add("fm-visible");

    // Trigger progress bar fills inside this section
    var fills = el.querySelectorAll(".fm-breakdown__fill[data-progress]");
    fills.forEach(function (fill) {
      fill.style.width = fill.getAttribute("data-progress") + "%";
    });
  }

  function initRevealAnimations(root) {
    var animated = getScopedElements(root || document, ".fm-animate");

    if ("IntersectionObserver" in window) {
      var observer = new window.IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      animated.forEach(function (el) {
        if (el.getAttribute(REVEAL_OBSERVED_ATTR) === "true" || el.classList.contains("fm-visible")) return;
        el.setAttribute(REVEAL_OBSERVED_ATTR, "true");
        observer.observe(el);
      });
    } else {
      animated.forEach(function (el) {
        if (el.getAttribute(REVEAL_OBSERVED_ATTR) === "true" || el.classList.contains("fm-visible")) return;
        el.setAttribute(REVEAL_OBSERVED_ATTR, "true");
        reveal(el);
      });
    }
  }

  // --- Founder banner injection (FitMar brand products only) ---
  function isFitMarProduct() {
    var vendor = "";
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        vendor = window.ShopifyAnalytics.meta.product.vendor || "";
      }
    } catch (e) {}
    if (!vendor && window.meta && window.meta.product) {
      vendor = window.meta.product.vendor || "";
    }
    if (!vendor) {
      var og = document.querySelector('meta[property="og:brand"]');
      if (og) vendor = og.getAttribute("content") || "";
    }
    return vendor.toLowerCase().indexOf("fitmar") !== -1;
  }

  var FOUNDER_TRANSLATIONS = {
    cs: {
      quote: "„Do FitMaru vybírám jen to, co má poctivé složení a fakt dobře chutná.“",
      role: "zakladatel FitMar",
      alt: "Martin Klusák, zakladatel FitMar"
    },
    sk: {
      quote: "„Do FitMaru vyberám len to, čo má poctivé zloženie a naozaj dobre chutí.“",
      role: "zakladateľ FitMar",
      alt: "Martin Klusák, zakladateľ FitMar"
    },
    hu: {
      quote: "„A FitMarba csak olyan termékeket válogatok, amelyek összetétele tiszta, és az ízük igazán finom.“",
      role: "a FitMar alapítója",
      alt: "Martin Klusák, a FitMar alapítója"
    },
    pl: {
      quote: "„Do FitMaru wybieram tylko produkty z uczciwym składem, które naprawdę dobrze smakują.“",
      role: "założyciel FitMar",
      alt: "Martin Klusák, założyciel FitMar"
    },
    ro: {
      quote: "„Pentru FitMar aleg doar produse cu ingrediente curate și gust cu adevărat bun.“",
      role: "fondatorul FitMar",
      alt: "Martin Klusák, fondatorul FitMar"
    },
    nl: {
      quote: "„Voor FitMar selecteer ik alleen producten met eerlijke ingrediënten die echt goed smaken.”",
      role: "oprichter van FitMar",
      alt: "Martin Klusák, oprichter van FitMar"
    },
    sl: {
      quote: "„Za FitMar izbiram le izdelke s pošteno sestavo, ki so res dobrega okusa.“",
      role: "ustanovitelj FitMar",
      alt: "Martin Klusák, ustanovitelj FitMar"
    },
    de: {
      quote: "„Für FitMar wähle ich nur Produkte mit ehrlichen Zutaten aus, die wirklich gut schmecken.“",
      role: "Gründer von FitMar",
      alt: "Martin Klusák, Gründer von FitMar"
    }
  };

  var FOUNDER_DOMAIN_LOCALES = {
    "fitmar.cz": "cs",
    "www.fitmar.cz": "cs",
    "fitmar.sk": "sk",
    "www.fitmar.sk": "sk",
    "fitmar.hu": "hu",
    "www.fitmar.hu": "hu",
    "fitmar.pl": "pl",
    "www.fitmar.pl": "pl",
    "fitmar.ro": "ro",
    "www.fitmar.ro": "ro",
    "fitmar.be": "nl",
    "www.fitmar.be": "nl",
    "fitmar.nl": "nl",
    "www.fitmar.nl": "nl",
    "fitmar.si": "sl",
    "www.fitmar.si": "sl",
    "fitmarshop.de": "de",
    "www.fitmarshop.de": "de",
    "fitmar.ch": "de",
    "www.fitmar.ch": "de",
    "fitmar.at": "de",
    "www.fitmar.at": "de"
  };

  function getFounderLocale() {
    var host = (window.location.hostname || "").toLowerCase();
    var domainLocale = FOUNDER_DOMAIN_LOCALES[host];
    if (domainLocale) return domainLocale;

    var pageLocale = "";
    if (document.documentElement) {
      pageLocale = document.documentElement.getAttribute("lang") || "";
    }
    pageLocale = pageLocale.toLowerCase().split("-")[0];
    if (FOUNDER_TRANSLATIONS[pageLocale]) return pageLocale;

    return "cs";
  }

  function localizeFounderBanner(section) {
    var t = FOUNDER_TRANSLATIONS[getFounderLocale()] || FOUNDER_TRANSLATIONS.cs;
    var quote = section.querySelector(".fm-founder__quote");
    var role = section.querySelector(".fm-founder__signature span");
    var image = section.querySelector(".fm-founder__photo img");

    if (quote) quote.textContent = t.quote;
    if (role) role.textContent = t.role;
    if (image) image.alt = t.alt;
  }

  function buildFounderBanner() {
    var t = FOUNDER_TRANSLATIONS[getFounderLocale()] || FOUNDER_TRANSLATIONS.cs;

    var section = document.createElement("section");
    section.className = "fm-founder fm-animate";

    var photoWrap = document.createElement("div");
    photoWrap.className = "fm-founder__photo";
    var img = document.createElement("img");
    img.src = "https://popisky.fitmar.cz/martin.webp";
    img.alt = t.alt;
    img.loading = "lazy";
    photoWrap.appendChild(img);

    var content = document.createElement("div");
    content.className = "fm-founder__content";

    var quote = document.createElement("blockquote");
    quote.className = "fm-founder__quote";
    quote.textContent = t.quote;
    content.appendChild(quote);

    var sig = document.createElement("div");
    sig.className = "fm-founder__signature";
    var nameEl = document.createElement("strong");
    nameEl.textContent = "Martin Klusák";
    var roleEl = document.createElement("span");
    roleEl.textContent = t.role;
    sig.appendChild(nameEl);
    sig.appendChild(roleEl);
    content.appendChild(sig);

    section.appendChild(photoWrap);
    section.appendChild(content);
    return section;
  }

  function injectFounderBanner() {
    if (!isFitMarProduct()) return;
    var existingBanner = document.querySelector(".fm-founder");
    if (existingBanner) {
      localizeFounderBanner(existingBanner);
      return;
    }

    var desc = document.querySelector(".fm-desc");
    if (!desc) return;

    var children = [];
    for (var i = 0; i < desc.children.length; i++) {
      var el = desc.children[i];
      if (el.tagName === "SECTION" || el.tagName === "FIGURE") children.push(el);
    }

    var banner = buildFounderBanner();
    if (children.length === 0) {
      desc.appendChild(banner);
    } else {
      var midpoint = Math.floor(children.length / 2);
      desc.insertBefore(banner, children[midpoint]);
    }
  }

  function initComparisonScroll(root) {
    getScopedElements(root || document, ".fm-compare-wrap").forEach(function (wrap) {
      if (wrap.getAttribute(COMPARE_SCROLL_ATTR) === "true") return;

      wrap.setAttribute(COMPARE_SCROLL_ATTR, "true");
      wrap.addEventListener("scroll", function () {
        if (wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 2) {
          wrap.classList.add("fm-scrolled-end");
        } else {
          wrap.classList.remove("fm-scrolled-end");
        }
      });
    });
  }

  function initFitMarDescriptions(root) {
    var scope = root || document;

    injectFounderBanner();
    initCounters(scope);
    observeCounterMutations(scope);
    initRevealAnimations(scope);
    initComparisonScroll(scope);
  }

  function rerunCountersSoon(root) {
    window.setTimeout(function () {
      initCounters(root || document);
      observeCounterMutations(root || document);
    }, 0);
  }

  function bindGlobalHooks() {
    var api = window.FitMarDescriptions = window.FitMarDescriptions || {};
    if (api._hooksBound) return;

    api._hooksBound = true;

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        initFitMarDescriptions(document);
      });
    }

    window.addEventListener("load", function () {
      initFitMarDescriptions(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      initFitMarDescriptions(event.target || document);
    });

    document.addEventListener("click", function (event) {
      var target = event.target;
      var tab = target && target.closest
        ? target.closest('[role="tab"], [data-tab-btn], .product-tabs__tab, .product-tabs__summary')
        : null;

      if (tab) rerunCountersSoon(document);
    });

    document.addEventListener("toggle", function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches("details.product-tabs__item") || !target.open) return;

      rerunCountersSoon(target);
    }, true);
  }

  window.FitMarDescriptions = window.FitMarDescriptions || {};
  window.FitMarDescriptions.initCounters = initCounters;
  window.FitMarDescriptions.init = initFitMarDescriptions;

  bindGlobalHooks();
  initFitMarDescriptions(document);
})();
